// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SolanaPowered_solanaPowered__DKiNu {
  background: #050518;
}

.SolanaPowered_container__hjEWZ {
  max-width: 90%;
}

.SolanaPowered_title__DMqAs {
  font-size: 3rem;
  margin-bottom: 4rem;
  text-align: center;
}

.SolanaPowered_features__cf4Cy {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.SolanaPowered_feature__T2ILT {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 16px;
  padding: 2rem;
  text-align: left;
  transition: all 0.3s ease;
  z-index: 1;
}

.SolanaPowered_feature__T2ILT::before {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: 17px;
  padding: 1.5px;
  background: linear-gradient(45deg, rgba(114, 43, 255, 1), rgba(204, 151, 244, 1));
  mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.SolanaPowered_feature__T2ILT:hover {
  transform: translateY(-5px);
}

.SolanaPowered_feature__T2ILT:hover::before {
  opacity: 1;
}

.SolanaPowered_icon__8NuX3 {
  background: #fff;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 64px;
}

.SolanaPowered_icon__8NuX3 svg {
  color: #050518;
}

.SolanaPowered_feature__T2ILT h3 {
  margin-bottom: 16px;
  color: var(--text);
}

.SolanaPowered_feature__T2ILT p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .SolanaPowered_title__DMqAs {
    font-size: 2rem;
    margin-bottom: 2rem;
    text-align: left;
  }
  
  .SolanaPowered_features__cf4Cy {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/SolanaPowered/SolanaPowered.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iFAAiF;EAIjF;;6BAE2B;EAE3B,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".solanaPowered {\n  background: #050518;\n}\n\n.container {\n  max-width: 90%;\n}\n\n.title {\n  font-size: 3rem;\n  margin-bottom: 4rem;\n  text-align: center;\n}\n\n.features {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.feature {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: left;\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n\n.feature::before {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  border-radius: 17px;\n  padding: 1.5px;\n  background: linear-gradient(45deg, rgba(114, 43, 255, 1), rgba(204, 151, 244, 1));\n  -webkit-mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.feature:hover {\n  transform: translateY(-5px);\n}\n\n.feature:hover::before {\n  opacity: 1;\n}\n\n.icon {\n  background: #fff;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 64px;\n}\n\n.icon svg {\n  color: #050518;\n}\n\n.feature h3 {\n  margin-bottom: 16px;\n  color: var(--text);\n}\n\n.feature p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 2rem;\n    margin-bottom: 2rem;\n    text-align: left;\n  }\n  \n  .features {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"solanaPowered": `SolanaPowered_solanaPowered__DKiNu`,
	"container": `SolanaPowered_container__hjEWZ`,
	"title": `SolanaPowered_title__DMqAs`,
	"features": `SolanaPowered_features__cf4Cy`,
	"feature": `SolanaPowered_feature__T2ILT`,
	"icon": `SolanaPowered_icon__8NuX3`
};
export default ___CSS_LOADER_EXPORT___;
